<template>
    <component
        :is="as"
        class="group-container rounded-2xl p-4 sm:p-5"
    >
        <slot/>
    </component>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    as?: string
}>(), {
    as: 'div',
})
</script>

<style scoped>
.group-container {
    background: linear-gradient(
        135deg,
        color-mix(in oklch, var(--color-primary) 6%, transparent) 0%,
        color-mix(in oklch, var(--color-primary-light) 4%, transparent) 46%,
        transparent 82%
    );
}
</style>
